var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.observations.length > 0)?_c('apexchart',{attrs:{"height":"125","type":"area","series":_vm.series,"options":_vm.options}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }